import { render, staticRenderFns } from "./UEditorRichText.vue?vue&type=template&id=095c9ef5&"
import script from "./UEditorRichText.vue?vue&type=script&lang=js&"
export * from "./UEditorRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports